export default {
  navigationBarTitleText: 'jssdkDemo'
};
